export default __webpack_public_path__ + "static/cover-image-684a927b691d84fa885abdf6a3bcd40b.jpg";